import { useQuery } from '@apollo/client'
import React, { FC, createContext } from 'react'
import { ILookDetail } from '../components/types'
import { createLookBookDetailData } from '../lib/createLookBookDetail'
import { LOOKBOOK_ITEM } from '../queries/lookbook'
import {
  lookbook_item,
  lookbook_itemVariables,
} from '../__generated__/lookbook_item'

interface ILookBookDetailContext {
  itemData: ILookDetail
}

export const LookBookDetailContext = createContext({} as ILookBookDetailContext)

const LookBookDetailProvider: FC<{ code: string }> = ({ children, code }) => {
  const vars: lookbook_itemVariables = {
    where: {
      code: {
        equals: code,
      },
      active: { equals: true },
    },
  }

  const { data } = useQuery<lookbook_item, lookbook_itemVariables>(
    LOOKBOOK_ITEM,
    { variables: vars },
  )

  const itemData = createLookBookDetailData(data?.item)

  return (
    <LookBookDetailContext.Provider value={{ itemData }}>
      {children}
    </LookBookDetailContext.Provider>
  )
}
export default LookBookDetailProvider
